<template>
    <ui-modal>
        <template #header>
            <h3 class="mb-1 text-center" v-text="'Twój pakiet'" />
        </template>

        <div v-if="tariff" class="drs-tariff-preview">
            <div class="drs-tariff-preview__row d-flex align-items-center justify-content-between w-100">
                <h5 class="mb-0" v-text="tariff.name" />
            </div>
            <div class="drs-tariff-preview__row mt-4 d-flex gap-1 justify-content-between">
                <div class="drs-tariff-preview__features">
                    <p v-text="'Pakiet obejmuje:'" class="font-weight-bold mb-1" />
                    <ul class="list-unstyled mb-1">
                        <li
                            v-for="(feature, fIdx) of tariff.features.list"
                            class="drs-tariff-preview__feature"
                            :key="fIdx"
                        >
                            <a-icon icon="Ok" width="16" />
                            <span v-text="feature.label" />
                            <a-icon
                                v-if="feature.tooltip"
                                v-tooltip="feature.tooltip"
                                icon="Info"
                                width="16"
                                class="text-primary"
                            />
                        </li>
                    </ul>
                </div>
                <div class="drs-tariff-preview__price d-flex flex-column mt-auto">
                    <template v-if="isDiscounted">
                        <div class="drs-tariff-preview__row mt-1 gap-1">
                            <span class="text-sm">
                                Do {{ discountedPriceDate }}
                            </span>
                            <span class="font-weight-bold">
                                {{ tariff.discounted_price | currency }} / mies.
                            </span>
                        </div>
                        <div class="drs-tariff-preview__row text-orange">
                            <span class="text-sm">
                                Od {{ discountedPriceNextDay }}
                            </span>
                            <span class="font-weight-bold">
                                {{ tariff.price | currency }} / mies.
                            </span>
                        </div>
                        <div v-if="areExtremesValid" class="drs-tariff-preview__savings text-right font-weight-bold">
                            <template v-if="tariffSavings > 0">
                                oszczędzasz {{ tariffSavings }}%*
                            </template>
                        </div>
                    </template>
                    <template v-else>
                        {{ tariff.price | currency }} / mies.
                    </template>
                </div>
            </div>

            <hr>

            <div class="drs-tariff-preview__row d-flex align-items-center justify-content-between w-100 mt-4">
                <h6 class="mb-0" v-text="'Opcjonalnie (stała kwota za dowolną liczbę urządzeń w ramach limitu):'" />
            </div>
            <div class="drs-tariff-preview__row mt-2 d-flex gap-1 justify-content-between">
                <ul class="drs-tariff-preview__features pl-3 mb-0">
                    <li v-for="(feature, fIdx) of tariff.optionals.list" :key="fIdx" v-text="feature.name" />
                </ul>

                <div class="drs-tariff-preview__price d-flex flex-column">
                    <template v-if="isDiscounted">
                        <div class="drs-tariff-preview__row gap-1">
                            <span class="text-sm">
                                Do {{ discountedPriceDate }}
                            </span>
                            <span class="font-weight-bold">
                                {{ tariff.devices_discounted_price | currency }} / mies.
                            </span>
                        </div>
                        <div class="drs-tariff-preview__row text-orange">
                            <span class="text-sm">
                                Od {{ discountedPriceNextDay }}
                            </span>
                            <span class="font-weight-bold">
                                {{ tariff.devices_price | currency }} / mies.
                            </span>
                        </div>
                        <div v-if="areExtremesValid" class="drs-tariff-preview__savings text-right font-weight-bold">
                            <template v-if="devicesSavings > 0">
                                oszczędzasz {{ devicesSavings }}%*
                            </template>
                        </div>
                    </template>
                    <template v-else>
                        {{ tariff.devices_price | currency }} / mies.
                    </template>
                </div>
            </div>
        </div>

        <div v-else v-text="'Brak danych'" />
    </ui-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters('drsTariffs', ['tariffs']),

        tariff () {
            return this.tariffs.find(({ id }) => id === this.$store.getters.modalState.args?.tariff_id)
        },

        isDiscounted() {
            return this.tariff.discounted_price && this.tariff.discounted_price < this.tariff.price
        },

        discountedPriceDate() {
            return this.$moment(this.tariff.discounted_price_date_to).format('DD.MM.YYYY')
        },

        discountedPriceNextDay() {
            return this.$moment(this.tariff.discounted_price_date_to).add(1, 'day').format('DD.MM.YYYY')
        }
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.drs-tariff-preview {
    --border-width: 2px;
    padding: 1.5rem 1rem;
    border: var(--border-width) solid var(--color-dark);
    border-radius: 4px;
    color: var(--color-primary);
    background-color: var(--active-promo-bg);
    border-color: var(--color-dark);

    &__features {
        flex-shrink: 0;
    }

    &__price {
        text-align: right;
    }

    &__feature {
        display: flex;
        align-items: center;
        gap: 0.25rem;
    }

    @include media-breakpoint-down(sm) {
        &__row {
            flex-wrap: wrap;
        }

        &__features {
            width: 100%;
        }

        &__price {
            text-align: left;
        }
    }
}
</style>